// extracted by mini-css-extract-plugin
export default {"button":"Button_button__KXFVC","auth":"Button_auth__EXCk7","back":"Button_back__FUeeB","link":"Button_link__TYLj6"};